/* eslint-disable react/prop-types */
import React from 'react';
import moment from 'moment';
import 'moment/min/locales';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const InpiPuntu = '926246828'

export const Receipt = ({
  data, company, user}) => {
  const date = moment(data.dtRegister, 'YYYY-MM-DD HH:mm:ss').locale('pt-br');
  const fields = [
    {
      name: 'CNPJ: ',
      prop: 'cnpj',
      from: company[0],
    },
    {
      name: 'LOCAL: ',
      prop: 'addressLocation',
      from: data,
    },
    {
      name: 'TIPO: ',
      prop: 'type',
      from: data,
    },
    {
      name: 'NOME: ',
      prop: 'employeeName',
      from: user,
    },
    {
      name: 'CPF: ',
      prop: '_cpf',
      from: data,
    },
    {
      name: 'PIS: ',
      prop: 'pis',
      from: company[0],
    },
  ];

  return (
    <div>
      <div style={{ backgroundColor: '#FEFFEE', maxWidth: '400px', padding: '20px' }}>
        <div style={{ fontWeight: 'bold', textAlign: 'center', marginBottom: '20px' }}>
          {/* Batida de ponto */}
          COMPROVANTE DE REGISTRO DE PONTO DO TRABALHADOR
        </div>

        <div style={{ marginTop: '', fontSize: 14 }}>
          <span style={{ fontWeight: 'bold' }}>RAZÃO SOCIAL:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{company[0].businessName}</span>
        </div>
        <div style={{ marginTop: '5px', marginBottom: '5px', fontSize: 14 }}>
          <span style={{ fontWeight: 'bold' }}>NSR:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{data.nsr}</span>
        </div>

        {
          fields.map(field => (
            <div style={{ flexDirection: 'row', marginBottom: 10 }}>
              <span style={{ fontWeight: 'bold' }}>
                {field.name}
                <span style={{ fontWeight: 'normal' }}>
                  {
                    field.prop !== 'type' ?
                      (field.from[field.prop] && field.from[field.prop].length ? field.from[field.prop] : 'NÃO CADASTRADO') :
                      (field.from[field.prop] === 'O' ? 'Saída' : 'Entrada')
                  }
                </span>
              </span>
            </div>
          ))
        }

        <div style={{ flexDirection: 'row', marginBottom: 10 }}>
          <span style={{ fontWeight: 'bold' }}>DATA:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{date.format('DD/MM/YYYY')}</span>

          <span style={{ fontWeight: 'bold', marginLeft: '60px' }}>{'   '}HORA:</span>
          <span style={{ fontWeight: 'normal' }}>{' '}{date.format('HH:mm:ss')}</span>

        </div>

        <div style={{ marginTop: '5px', fontSize: 14 }}>
          <span style={{ marginRight: 44, textAlign: 'left' }}>Puntu - Ponto Digital</span>
          <span style={{ textAlign: 'right' }}>  INPI: {InpiPuntu}</span>
        </div>
        <div style={{ marginTop: 5, fontSize: 10, opacity: 0.5, textAlign: 'center' }}>Hash: {data.hash256 || ''} </div>
      </div>
    </div>
  );
};
